<template>
    <header id="header" v-if="profile">
 
      <div class="centered">
        <router-link to='/' id="logo"></router-link>
       
        <ul id="menu" v-if="!is_mobile()">
            <li class="dropdownW3"><router-link  to="/category/88">סרטים</router-link>
                <div class="dropdown-contentW3">
                          <div v-for="item in menu" class="active" :key="'menu' + item.link" ><router-link :to="'/' + item.link + '/type/1'">{{ item.name }}</router-link></div>
                  </div>
            </li>
             <li class="dropdownW3"><router-link  to="/category/88">סדרות</router-link>
                <div class="dropdown-contentW3">
                          <a v-for="item in menu" class="active" :key="'menu' + item.link" ><router-link :to="'/' + item.link + '/type/2'">{{ item.name }}</router-link></a>
                  </div>
            </li>
            <!-- <li><router-link to="/category/88">הופעות ואירועים</router-link></li> -->
            <li><router-link to="/favorites">הרשימה שלי</router-link></li>
            <li v-if="live.id > 0" class="btn_live"><router-link to="/live">שידור חי</router-link></li>
            <li v-if="!user_data.is_active" class="upgrade" @click="$emit('open_pay')">שדרוג למנוי פרימיום</li>
          </ul>

          <!--  <li><router-link :to="'/user/profiles/edit/' + profile.id" style="color: #dd1a7b;font-weight: 800;" v-if="profile.has_perms == '1'" > הפרופיל שלי</router-link></li>-->

        <div id="haeder_left_area"  v-if="!is_mobile()">

          <div id="time_left" v-if="show_time_left">
            <countdown :time="time_left">
              <template slot-scope="props">
                  
                  <ul id="clock">
                      <li>
                        <label>{{ props.seconds }}</label>
                        <span><strong>שניות</strong></span>
                      </li>
                      <li>
                        <label>{{ props.minutes }}</label>
                        <span><strong>דקות</strong></span>
                      </li>
                      <li>
                        <label>{{ props.hours }}</label>
                        <span><strong>שעות</strong></span>
                      </li>
                      <li>
                        <label>{{ props.days }}</label>
                        <span><strong>ימים</strong></span>
                      </li>
                  </ul>
                
                </template>
            </countdown>

            

            <span>
              <strong>זה הזמן שנותר למנוי</strong><br> הגיע הזמן להצטרף, לא? :) <a style="text-decoration:underline;" :href="'https://www.tov.tv/joinus/pay?token=' + user_token">לחץ כאן</a>
            </span>
          </div>

          <ul>
            <li><a class="pic_btn" id="help_btn" href="https://www.tov.tv/questions" target="_blank"></a></li>
            <li><a class="pic_btn" id="search_btn" @click="open_search()"></a></li>
            <li>
              <!-- <router-link to='user'><span class="pic_btn" id="user_btn"></span> {{ user_data.display_name }}</router-link> -->
              <div style="cursor:pointer;" @click="show_user_menu=!show_user_menu"><span class="pic_btn" id="user_btn"></span> {{ profile.name }}</div>

              <div id="user_menu" v-if="show_user_menu" v-on-clickaway="away">
                <ul>
                   
                  <li class="profile_link" v-for="profile_item in user_data.profiles" :key="profile_item.id" @click="change_profile(profile_item.id)"><div class="pic"></div><span>{{ profile_item.name }}</span></li>
                  <li v-if="profile.has_perms == '1' "><router-link to='/user/profiles'>נהל פרופילים</router-link></li>
                </ul>
                
                <div style="border-bottom:1px solid #333;"></div>

                <ul>
                   <li ><router-link to='/contact'>צור קשר</router-link></li>
                  <li><router-link to='/user'>חשבון</router-link></li>
                  <li><a @click="logout()">יציאה מ-TovTv</a></li>
                </ul>
                
              </div>


            </li>
          </ul>
        </div>

      </div>


    </header>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  mixins: [ clickaway ],

  props: ["user_data", "menu","profile", "live"],
  
  data() {
    return {
      show_user_menu: false,
      user_token: localStorage.getItem('user_token')
    };
  },
  
  computed: {
    // a computed getter
    time_left: function () {
      /*var myDate=this.user_data.subscription_validity.split("-");
var newDate=myDate[1]+"/"+myDate[0]+"/"+myDate[2];
return (new Date(newDate).getTime());
*/
      return (new Date(this.user_data.subscription_validity).getTime() - new Date().getTime());

    },
    show_time_left: function () { 
      return (this.user_data.user_status == 'free' || this.time_left > 0);

    }
  },
  methods:{
    open_search(){
      this.$emit('open_search', true);
    },

    change_profile(id){

      var curr_profile = false;
      for (let i in this.user_data.profiles)
      {
        if (this.user_data.profiles[i].id == id) 
        {
          curr_profile = this.user_data.profiles[i];
          break;
        }
      }
      if (curr_profile)
      {
        if (curr_profile.password != '')
        {
          var pass = prompt("סיסמה:");
          if (pass != curr_profile.password)
          {
            alert('הסיסמה אינה נכונה, אנא נסה שנית');
            return;
          }
          
        }

        this.api_call({ url: 'change_profile', data: {id: id}, onComplete: function(data){
                      localStorage.setItem('user_token', data.data.data);
                      document.location = '/';

        }});
        
      }
    },
    
    logout(){
      localStorage.removeItem('user_token');
      document.location = '/';

    },
    
    away: function() {
      this.show_user_menu = false;
    },
  },


}
</script>